import { useQueryClient } from '@tanstack/react-query';
import { getDeerReviewCycleRoute } from 'Deer/constants/nonDeerRoutes';
import { useHistory } from 'react-router-dom';
import {
  REVIEW_CYCLE_STEPS_ORDER,
  REVIEW_CYCLE_STEPS_V1,
  REVIEW_FORM_STAGE,
  useReviewCreationData,
} from 'reducers/reviewCreationSlice';
import { checkNewNavEnabled } from 'utils/helpers/featureFlags';

import { goToReviewCycle } from 'constants/helper';
import { REACT_QUERY_KEYS } from 'constants/reactQueryKeys';

export const useReviewCreationNavigation = () => {
  const history = useHistory();
  const queryClient = useQueryClient();

  const { reviewCycleId, step, currentStage } = useReviewCreationData();

  const goToNextStep = ({ reviewCycleIdFromApi = null } = {}) => {
    const validReviewCycleSteps =
      currentStage === REVIEW_FORM_STAGE.DRAFT
        ? REVIEW_CYCLE_STEPS_ORDER
        : REVIEW_CYCLE_STEPS_ORDER.filter((step) => step !== REVIEW_CYCLE_STEPS_V1.VALIDATION);

    const currentIndex = validReviewCycleSteps.indexOf(step);
    if (currentIndex === validReviewCycleSteps.length - 1) {
      return;
    }

    const nextStep = validReviewCycleSteps[currentIndex + 1];
    if (checkNewNavEnabled()) {
      const routeToGo = getDeerReviewCycleRoute(reviewCycleIdFromApi ?? reviewCycleId, nextStep);
      history.push(routeToGo);
    } else {
      goToReviewCycle({
        history,
        entityId: reviewCycleIdFromApi ?? reviewCycleId,
        step: nextStep,
      });
    }
    // to refetch review details: mainly to update the last enabled section
    queryClient.invalidateQueries([REACT_QUERY_KEYS.reviewCreation.NAME]);
  };

  const goToPrevStep = () => {
    const validReviewCycleSteps =
      currentStage === REVIEW_FORM_STAGE.DRAFT
        ? REVIEW_CYCLE_STEPS_ORDER
        : REVIEW_CYCLE_STEPS_ORDER.filter((step) => step !== REVIEW_CYCLE_STEPS_V1.VALIDATION);

    const currentIndex = validReviewCycleSteps.indexOf(step);
    if (currentIndex === 0) {
      return;
    }
    const previousStep = validReviewCycleSteps[currentIndex - 1];
    if (checkNewNavEnabled()) {
      const routeToGo = getDeerReviewCycleRoute(reviewCycleId, previousStep);
      history.push(routeToGo);
    } else {
      goToReviewCycle({ history, entityId: reviewCycleId, step: previousStep });
    }
  };

  const goToStep = (step) => {
    if (checkNewNavEnabled()) {
      const routeToGo = getDeerReviewCycleRoute(reviewCycleId, step);
      history.push(routeToGo);
    } else {
      goToReviewCycle({ history, entityId: reviewCycleId, step });
    }
  };

  return { goToNextStep, goToPrevStep, goToStep };
};
